<template>
  <div>
    <Head title="Creators" />
    <h1 class="mb-8 text-3xl font-bold">Influencer</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Influencer:</label>
        <select v-model="form.influencer" class="form-select mt-1 w-full">
          <option value="1">Influencer</option>
          <option value="0">Not an Influencer</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/creator/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Influencer</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">S.No</th>
          <th class="pb-4 pt-6 px-6">Name</th>
          <th class="pb-4 pt-6 px-6">Influencer</th>
          <th class="pb-4 pt-6 px-6">Employee ID</th>
        </tr>
        <tr v-for="(creator, index) in creator.data" :key="creator.crtr_id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <!-- S.No column -->
          <td class="border-t px-6 py-4">
              {{ index + 1 }}
          </td>

          <!-- Creator Name -->
          <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/creator/${creator.crtr_id}/edit`" tabindex="-1">
                  {{ creator.crtr_name }}
              </Link>
          </td>

          <!-- Is Influencer -->
          <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/creator/${creator.crtr_id}/edit`" tabindex="-1">
                <span v-if="creator.crtr_is_influencer === 1" class="text-blue-500 font-semibold">Influencer</span>
                <span v-else-if="creator.crtr_is_influencer === 2" class="text-green-500 font-semibold">Anchor</span>
                <span v-else class="text-yellow-500 font-semibold">Employee</span>
              </Link>
          </td>
          <!-- employee Id -->
          <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/creator/${creator.crtr_id}/edit`" tabindex="-1">
                  {{ creator.crtr_is_influencer === 0 ? creator.pkm_empl_id : 'N/A' }}
                </Link>
            </td>
          <!-- Action Icon -->
          <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/creator/${creator.crtr_id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
          </td>
      </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="creator.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    creator: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        influencer: this.filters.influencer,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/creator', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
